import React from 'react';

import { Props } from './types';

export const Image = ({ src, alt = '', respectPixelRatio = false, ...props }: Props) => {
  if (respectPixelRatio) {
    // Split string by last DOT “.”
    const [path, ext] = src.split(/\.(?=[^.]+$)/);
    // Add srcset image attribute to all image props

    props.srcSet = `${path}.${ext} 1x, ${path}@2x.${ext} 2x, ${path}@3x.${ext} 3x`;
  }

  return <img alt={alt} src={src} {...props} />;
};
